// Single source of truth for push-notification character caps (DATA-4894).
// Aligned to the platforms' rich-notification display limits, NOT the legacy
// single-field "{merchant} says …" budget:
//   Title    — iOS collapsed ~65 (the more permissive of iOS 65 / Android 40), DATA-4901
//   Subtitle — iOS only, ~40, DATA-4915
//   Body     — iOS expanded ≈ 6 lines ≈ 240, DATA-4894 FR#4
//
// Imported by the campaign push composer (Builder/components/Forms/Push.tsx,
// reused by Messaging/EditPush.tsx) and by the manual reward grant message
// (Users/View/GrantModal.tsx, DATA-5016) so the two stay in lockstep.
export const TITLE_MAX_LENGTH = 65
export const SUBTITLE_MAX_LENGTH = 40
export const BODY_MAX_LENGTH = 240

// Android renders far fewer title characters than iOS before truncating with an
// ellipsis (~40 vs ~65). The input cap stays at the more permissive iOS limit
// (TITLE_MAX_LENGTH); this is the display-only threshold the Android device
// preview uses to mirror what an Android device actually shows. DATA-4901.
export const ANDROID_TITLE_DISPLAY_LENGTH = 40
